import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImageDetail } from '@bookinglab/govbook-ui';
import { NavLink } from '@bookinglab/govbook-ui/layout';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import { DatastoreService } from '../../services';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-header',
	standalone: true,
	imports: [CommonModule, GbHeaderComponent],
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
	constructor(private datastoreService: DatastoreService) {}

	login() {
		window.open(environment.loginUrl, '_blank');
	}

	isAdmin() {
		return this.datastoreService.adminJourney;
	}
	imageDetail: ImageDetail = {
		alt: 'Barnsley Council Logo',
		src: 'assets/images/barnsley_logo.svg',
	};

	navigation: NavLink[] = [
		{
			text: 'Marriages and civil partnerships',
			url: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/',
		},
		{
			text: 'Give notice',
			url: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/give-notice-of-marriage-or-civil-partnership/',
		},
		{
			text: 'Fees',
			url: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/registration-charges/',
		},
		{
			text: 'Baby naming ceremonies',
			url: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/births/baby-naming-ceremonies/',
		},
		{
			text: 'Book a registrar',
			url: 'https://www.barnsley.gov.uk/services/births-deaths-and-marriages/marriages-and-civil-partnerships/book-a-registrar-for-your-wedding-or-civil-partnership/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `https://www.barnsley.gov.uk/search?q=${formatted}`;
		window.location.href = url;
	}
}
